import logoW from "../images/OOVAL - sW.png";
import logoB from "../images/OOVAL - sB.png";

export const Logo = ({ color }) => {
  return (
    <div className="logo-container">
      <div
        className="logo-content"
        style={{ display: "flex", flexDirection: "column" }}
      >
        <img src={color == "white" ? logoW : logoB} alt="nologo" />
        <div
          className="logo-text"
          style={{ marginLeft: "0px", textAlign: "center" }}
        ></div>
      </div>
    </div>
  );
};
